import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import AppModal from "components/ui/AppModal";
import RefundButtonStatus from "./RefundButton";

function RefundOrderInfo({ rowData }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <AppModal
        open={open}
        width="rounded-md border border-gray-300 top-0"
        onClose={() => setOpen(false)}
      >

          <table class="border-collapse border border-slate-400 w-full my-8">
            {rowData?.refund?.amount >= 0 ? (
              <tr>
                <td className="border border-slate-300 p-4">
                  {t("Refunded Amount")}
                </td>
                <td className="border border-slate-300 p-4">
                  {rowData.refund?.amount} {t("AED")}
                </td>
              </tr>
            ) : null}
            {rowData?.refund?.amount >= 0 ? (
              <tr>
                <td className="border border-slate-300 p-4">
                  {t("Refund Reason")}
                </td>
                <td className="border border-slate-300 p-4">
                  {rowData.refund?.reason}
                </td>
              </tr>
            ) : null}
            {rowData?.refund?.amount >= 0 ? (
              <tr>
                <td className="border border-slate-300 p-4">
                  {t("Refund Status")}
                </td>
                <td className="border border-slate-300 p-4">
                  {rowData?.refund?.status}
                </td>
              </tr>
            ) : null}
            {
              rowData?.refund?.metaResponse?.result?.description ? (
                <tr>
                  <td className="border border-slate-300 p-4">
                    {t("Refund Failure Reason")}
                  </td>
                  <td className="border border-slate-300 p-4">
                    {rowData?.refund?.metaResponse?.result?.description}
                  </td>
                </tr>
              ) : null
            }
            {rowData?.refund?.amount >= 0 ? (
              <tr>
                <td className="border border-slate-300 p-4">
                  {t("Refund Request Date")}
                </td>
                <td className="border border-slate-300 p-4">
                  {
                    rowData?.refund?.metaResponse?.timestamp ? moment(rowData?.refund?.metaResponse?.timestamp).format("DD/MM/yyyy hh:mm A") :
                  moment
                    .unix(rowData?.refund?.stripeResponse?.created)
                    .format("DD/MM/yyyy hh:mm A")}
                </td>
              </tr>
            ) : null}
          </table>
      </AppModal>

      <RefundButtonStatus status={rowData?.refund?.status} setOpen={setOpen} />
    </>
  );
}

export default RefundOrderInfo;
